import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import PaginationDataTable from '../../Common/PaginationDataTable'
import { STOCK_TRANSFER_URL } from '../../../CONSTANTS'
import Select from "react-select";
import AddIcon from "@mui/icons-material/Add";
import toast, { Toaster } from 'react-hot-toast';
import DataTable from 'react-data-table-component';
import { Button } from 'react-bootstrap';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import Loader from '../../Common/Loader';
import { GetFgItemsReports } from '../../../services/Inventory/ItemService';
import EditIcon from '@mui/icons-material/Edit';

const FGsalesList = () => {
    var curr = new Date();
    curr.setDate(curr.getDate());
    var date1 = curr.toISOString().substring(0, 10);
    const [targetDate, setTargetDate] = useState(date1)
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [searchText, setSearchText] = useState("")
    const [data, setData] = useState([])
    



    useEffect(() => {
        getAllRecords();
    }, [targetDate])


    useEffect(() => {
        if (searchText) {
            let newData = data.filter((e) => e.title.toLocaleLowerCase().includes(searchText.toLocaleLowerCase()))
            setFilteredData(newData);
        }
        else {
            setFilteredData(data)
        }
    }, [searchText])

    const getAllRecords = () => {
        GetFgItemsReports(targetDate).then(((res) => {
            if (res.errorCode === 0) {
                let d = res.responsePacket.data;
                // d.reverse()
                setFilteredData(d);
                setData(d)
                setLoading(false)
            } else {
                setLoading(false)
                toast(res.message);
            }
        })).catch(error => {
            console.error(error);
            setLoading(false);
        });
    }
    const columns = [
        {
            name: 'Title',
            selector: (row) => (row.title),
        },
        {
            name: 'Target Date',
            selector: (row) => (row.selectedDate)
        },
        {
            name: 'ACTION',
            selector: (row) => (

                (<EditIcon
                    style={{ fontSize: '15px', cursor: 'pointer' }}
                    onClick={() => {
                        navigate('/salestarget/' + row.recordId + '/edit');
                    }}
                />)
            ),
        },
    ];




    return (
        <>
            <div className="p-4">
                <>
                    <div className="tab-content issuanceList" id="myTabContent">
                        <div className="tab-pane fade show active" id="issuanceList" role="tabpanel" aria-labelledby="activeList">
                            <DataTable
                                className='customDataTable'
                                title='Sales Target Lists'
                                data={filteredData}
                                pagination
                                fixedHeader
                                pointerOnHover={true}
                                highlightOnHover={true}
                                onRowClicked={(data) => navigate(`/salestarget/view/${"123"}`)}
                                subHeader
                                subHeaderComponent={
                                    <div className='d-flex align-items-center gap-2'>
                                        <div className='d-flex align-items-center ml-2'>
                                            <div className="d-flex align-items-center mr-2">
                                                <div className='input-group paginationSearchInput mr-0 pr-0' style={{ minWidth: "300px" }}>
                                                    <div className="input-group searchInput dateInput mr-3">
                                                        <div className="input-group-prepend">
                                                            <span
                                                                className="input-group-text font-weight-bold"
                                                                id="basic-addon1"
                                                            >
                                                                Target Date:
                                                            </span>
                                                        </div>
                                                        <input
                                                            autoComplete="off"
                                                            className=" form-control"
                                                            type="date"
                                                            value={targetDate}
                                                            onChange={(e) => setTargetDate(e.target.value)}
                                                        />
                                                        {/* <Button variant="contained" onClick={() => { }}>Search</Button> */}
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='input-group paginationSearchInput mr-2'>
                                                <div className='input-group-prepend'>
                                                    <span className='input-group-text' id='basic-addon1'>
                                                        <SearchRoundedIcon />
                                                    </span>
                                                </div>
                                                <input value={searchText} onChange={(e) => setSearchText(e.target.value)} autoComplete='off' className='form-control' type='text' placeholder='Search price list' />
                                            </div>
                                            <Link to='/salestarget/new' className='ember-view btn btn-primary d-flex align-items-center py-2 ml-2'>
                                                <AddIcon />
                                                New
                                            </Link>
                                            {/* <div className="btn-toolbar float-right">
                                                {assignSyncButton() && <button className='ember-view btn btn-primary d-flex align-items-center py-2 ml-2' onClick={toggleSyncModal}>
                                                    <SyncIcon /> Sync
                                                </button>}
                                            </div> */}
                                        </div>
                                    </div>
                                }
                                progressPending={loading}
                                progressComponent={<Loader />}
                                columns={columns}
                            />
                        </div>
                    </div>
                </>
            </div>
            <Toaster />
        </>
    )
}

export default FGsalesList